module.exports = __webpack_public_path__ + "static/media/profilemail.80ebcf00.svg";